import { Step, RegionCode } from '~/types'
import { Regions } from '~/models/region'

export const policyholderProxies = ['broker', 'agent', 'roadside assistance']

export const steps: Step[] = [
    {
        title: 'About You',
        slug: 'about-you',
    },
    {
        title: 'Tell Us About Your Driver',
        slug: 'about-driver',
    },
    {
        title: 'About Your Vehicle',
        slug: 'about-vehicle',
    },
    {
        title: 'Tell Us What Happened',
        slug: 'what-happened',
    },
    {
        title: 'Damage Details',
        slug: 'damage-details',
    },
    {
        title: 'Other Details',
        slug: 'other-details',
    },
]

export const stepsWithoutDriver: Step[] = [
    {
        title: 'About You',
        slug: 'about-you',
    },
    {
        title: 'About Your Vehicle',
        slug: 'about-vehicle',
    },
    {
        title: 'Tell Us What Happened',
        slug: 'what-happened',
    },
    {
        title: 'Damage Details',
        slug: 'damage-details',
    },
    {
        title: 'Other Details',
        slug: 'other-details',
    },
]

export const ACCEPTED_FILE_TYPES = [
    'application/pdf',
    'image/jpeg',
    'image/png',
    'video/mp4',
]

export const ACCEPTED_FILE_EXTENSIONS = ['pdf', 'jpg', 'jpeg', 'png', 'mp4']

export const MAX_FILE_SIZE_MB = 20
export const MAX_FILE_SIZE_BYTES = MAX_FILE_SIZE_MB * 1024 * 1024

export const TRN_LEN = {
    min: 100000000,
    max: 999999999,
}


export const DEFAULT_REGION: RegionCode = Regions.Barbados.code

export const REGION_TTL = 8 * 60 * 60 * 1000
